export default __webpack_public_path__ + "static/media/product_NPC_En.18fde399.webp";